/* ==========================================================================
   ROXX Relaunch 2026 — Vanilla JS
   - Sticky Add-to-Cart (mobil, variantenaware)
   - Cross-Sell Quick-Add (AJAX, meldet an den bestehenden Warenkorb)
   - Accordions
   Nutzt das Event, das Expanse ohnehin ueber document dispatched:
   'ajaxProduct:added' (siehe pubsub.js).
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    var fmt = (window.theme && (theme.moneyFormat || (theme.settings && theme.settings.moneyFormat))) || null;
    if (fmt && fmt.indexOf('{{') !== -1) {
      var value = (cents / 100).toFixed(2);
      if (fmt.indexOf('amount_with_comma_separator') !== -1) {
        value = value.replace('.', ',');
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'roxx-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  /* Sticky Add-to-Cart --------------------------------------------------- */

  function initStickyAtc() {
    var sticky = document.querySelector('[data-roxx-sticky]');
    if (!sticky || sticky.getAttribute('data-roxx-init') === 'true') return;

    var buyButtons = document.querySelector('block-buy-buttons');
    if (!buyButtons) {
      sticky.remove();
      return;
    }

    var realBtn = buyButtons.querySelector('[name="add"]');
    var idInput = buyButtons.querySelector('input[name="id"]');
    if (!realBtn || !idInput) {
      sticky.remove();
      return;
    }

    sticky.setAttribute('data-roxx-init', 'true');

    var stickyBtn = sticky.querySelector('[data-roxx-sticky-btn]');
    var priceEl = sticky.querySelector('[data-roxx-sticky-price]');
    var titleEl = sticky.querySelector('[data-roxx-sticky-title]');

    var variants = {};
    var dataEl = sticky.querySelector('[data-roxx-variants]');
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (v) {
          variants[String(v.id)] = v;
        });
      } catch (e) {
        /* Ohne Variantendaten bleibt der serverseitig gerenderte Preis stehen */
      }
    }

    function syncFromVariant() {
      var v = variants[String(idInput.value)];
      if (!v) return;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (titleEl && v.title && v.title !== 'Default Title') titleEl.textContent = v.title;
    }

    function syncButtonState() {
      var disabled = realBtn.hasAttribute('disabled');
      var label = realBtn.querySelector('span');
      stickyBtn.disabled = disabled;
      if (label && label.textContent.trim()) stickyBtn.textContent = label.textContent.trim();
    }

    idInput.addEventListener('change', function () {
      syncFromVariant();
      setTimeout(syncButtonState, 0);
    });

    if ('MutationObserver' in window) {
      new MutationObserver(syncButtonState).observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });
    }

    stickyBtn.addEventListener('click', function () {
      realBtn.click();
    });

    /* Sichtbarkeit: eine Rect-Messung pro Scroll-Event, Schreibzugriff nur
       bei echtem Zustandswechsel. Bewusst ohne IntersectionObserver, damit
       das Verhalten in jeder Umgebung identisch und testbar ist. */
    var visible = false;

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      sticky.classList.toggle('is-visible', next);
      var height = next ? sticky.offsetHeight : 0;
      document.documentElement.style.setProperty('--roxx-sticky-h', height + 'px');
      document.body.style.paddingBottom = next ? height + 'px' : '';
    }

    function measure() {
      // Nur mobil relevant; ab 768px ist die Leiste per CSS ausgeblendet.
      if (window.innerWidth >= 768) {
        setVisible(false);
        return;
      }
      setVisible(realBtn.getBoundingClientRect().bottom < 0);
    }

    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure, { passive: true });

    syncFromVariant();
    syncButtonState();
    measure();
  }

  /* Quick-Add ------------------------------------------------------------ */

  function initQuickAdd() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-roxx-quick-add]');
      if (!btn || btn.disabled) return;

      event.preventDefault();

      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          btn.removeAttribute('aria-busy');

          if (data.status === 422 || data.status === 'bad_request') {
            btn.disabled = false;
            toast(data.description || data.message || 'Konnte nicht hinzugefuegt werden.');
            return;
          }

          btn.classList.add('is-added');
          btn.textContent = btn.getAttribute('data-added-label') || 'Hinzugefügt';
          toast(btn.getAttribute('data-added-toast') || 'Zum Warenkorb hinzugefügt.');

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data, addToCartBtn: btn }
            })
          );

          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = original;
            btn.disabled = false;
          }, 3000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          toast('Es ist ein Fehler aufgetreten.');
        });
    });
  }

  /* Accordions ----------------------------------------------------------- */

  function initAccordions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-roxx-acc-trigger]');
      if (!trigger) return;

      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  }

  function boot() {
    initStickyAtc();
    initQuickAdd();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initStickyAtc();
  });
})();